export default "__VITE_ASSET__BhC4Aj88__"